var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '@angular/core';
import * as moment from 'moment-timezone';
import { AppConstant } from '../app.constant';
var TaskSampleCSV = /** @class */ (function () {
    function TaskSampleCSV() {
        this.categoryConst = AppConstant.BUSSINESS_TYPE;
        this.pick_delivery = [
            {
                name: 'Pickup_Name',
                countryCode: '91',
                phone: '9158592393',
                email: 'email@gmail.com',
                FlatNo: '#44, 2nd floor, 1st cross, 2nd Main Rd',
                Area: 'Prasanth Layout',
                address: 'Prasanth Extension, Whitefield, Bengaluru, Karnataka 560066',
                latitude: '12.9839174',
                longitude: '77.7478632',
                date: moment(new Date()).format('MMM DD YYYY'),
                time: moment(new Date()).format('HH:mm'),
                driver: '70200025',
                city: 'bangalore',
                country: 'india',
                orderId: 54322,
                description: 'description',
                isPickup: 2,
                DeliveryName: 'Delivery_Name',
                DeliveryCountry_code: '91',
                DeliveryPhone: '9158592393',
                DeliveryEmail: 'email@gmail.com',
                DeliveryFlatNo: '#44, 2nd floor',
                DeliveryArea: 'Prasanth Layout',
                DeliveryAddress: 'Arni Road, Arni Road, Kuppam, opposite Blue Theatre, RV Nagar, Vellore, Tamil Nadu 632002, India',
                DeliveryLatitude: '12.892381798393078',
                DeliveryLongitude: '79.13564139929196',
                DeliveryDate: moment(new Date()).format('MMM DD YYYY'),
                DeliveryTime: moment(new Date()).add(1, 'hours').format('HH:mm'),
                DeliveryCity: 'vellore',
                DeliveryCountry: 'india',
                DeliveryOrder_id: '645343',
                DeliveryDescription: 'description'
            },
            {
                name: 'Pickup_Name',
                countryCode: '91',
                phone: '9030263984',
                email: 'email@gmail.com',
                FlatNo: '#44, 2nd floor, 1st cross, 2nd Main Rd',
                Area: 'Prasanth Layout',
                address: 'Prasanth Extension, Whitefield, Bengaluru, Karnataka 560066',
                latitude: '12.9839174',
                longitude: '77.7478632',
                date: moment(new Date()).format('MMM DD YYYY'),
                time: moment(new Date()).format('HH:mm'),
                driver: '70200025',
                city: 'bangalore',
                country: 'india',
                orderId: 1450,
                description: 'description',
                isPickup: 1,
                DeliveryName: '',
                DeliveryCountry_code: '',
                DeliveryPhone: '',
                DeliveryEmail: '',
                DeliveryFlatNo: '',
                DeliveryArea: '',
                DeliveryAddress: '',
                DeliveryLatitude: '',
                DeliveryLongitude: '',
                DeliveryDate: '',
                DeliveryTime: '',
                DeliveryCity: '',
                DeliveryCountry: '',
                DeliveryOrder_id: '',
                DeliveryDescription: ''
            },
            {
                name: 'Delivery_Name',
                countryCode: '91',
                phone: '9493781078',
                email: 'email@gmail.com',
                FlatNo: '#44, 2nd floor, 1st cross, 2nd Main Rd',
                Area: 'Prasanth Layout',
                address: 'Prasanth Extension, Whitefield, Bengaluru, Karnataka 560066',
                latitude: '12.9839174',
                longitude: '77.7478632',
                date: moment(new Date()).format('MMM DD YYYY'),
                time: moment(new Date()).format('HH:mm'),
                driver: '70200025',
                city: 'bangalore',
                country: 'india',
                orderId: 1451,
                description: 'description',
                isPickup: 0,
                DeliveryName: '',
                DeliveryCountry_code: '',
                DeliveryPhone: '',
                DeliveryEmail: '',
                DeliveryFlatNo: '',
                DeliveryArea: '',
                DeliveryAddress: '',
                DeliveryLatitude: '',
                DeliveryLongitude: '',
                DeliveryDate: '',
                DeliveryTime: '',
                DeliveryCity: '',
                DeliveryCountry: '',
                DeliveryOrder_id: '',
                DeliveryDescription: ''
            }
        ];
        this.appointment = [
            {
                name: 'Appointment_Name_1',
                countryCode: '91',
                phone: '9030263984',
                email: 'email@gmail.com',
                FlatNo: '#44, 2nd floor, 1st cross, 2nd Main Rd',
                Area: 'Prasanth Layout',
                address: 'Prasanth Extension, Whitefield, Bengaluru, Karnataka 560066',
                latitude: '12.9839174',
                longitude: '77.7478632',
                sdate: moment(new Date()).format('MMM DD YYYY'),
                stime: moment(new Date()).format('HH:mm'),
                edate: moment(new Date()).format('MMM DD YYYY'),
                etime: moment(new Date()).add(1, 'minutes').format('HH:mm'),
                driver: '70200025',
                city: 'bangalore',
                country: 'india',
                orderId: 1450,
                description: 'description',
            },
            {
                name: 'Appointment_Name_2',
                countryCode: '91',
                phone: '9493781078',
                email: 'email@gmail.com',
                FlatNo: '#44, 2nd floor, 1st cross, 2nd Main Rd',
                Area: 'Prasanth Layout',
                address: 'Prasanth Extension, Whitefield, Bengaluru, Karnataka 560066',
                latitude: '',
                longitude: '',
                sdate: moment(new Date()).format('MMM DD YYYY'),
                stime: moment(new Date()).format('HH:mm'),
                edate: moment(new Date()).format('MMM DD YYYY'),
                etime: moment(new Date()).add(1, 'minutes').format('HH:mm'),
                driver: '',
                city: 'bangalore',
                country: 'india',
                orderId: 1451,
                description: 'description',
            },
            {
                name: 'Appointment_Name_3',
                countryCode: '91',
                phone: '9493781078',
                email: 'email@gmail.com',
                FlatNo: '#44, 2nd floor, 1st cross, 2nd Main Rd',
                Area: 'Prasanth Layout',
                address: 'Prasanth Extension, Whitefield, Bengaluru, Karnataka 560066',
                latitude: '',
                longitude: '',
                sdate: moment(new Date()).format('MMM DD YYYY'),
                stime: moment(new Date()).format('HH:mm'),
                edate: moment(new Date()).format('MMM DD YYYY'),
                etime: moment(new Date()).add(1, 'minutes').format('HH:mm'),
                driver: '',
                city: 'bangalore',
                country: 'india',
                orderId: 1451,
                description: 'description',
            }
        ];
        this.workForce = [
            {
                name: 'Field_Work_Force_Name_1',
                countryCode: '91',
                phone: '9030263984',
                email: 'email@gmail.com',
                FlatNo: '#44, 2nd floor, 1st cross, 2nd Main Rd',
                Area: 'Prasanth Layout',
                address: 'Prasanth Extension, Whitefield, Bengaluru, Karnataka 560066',
                latitude: '12.427680',
                longitude: '76.451653',
                sdate: moment(new Date()).format('MMM DD YYYY'),
                stime: moment(new Date()).format('HH:mm'),
                edate: moment(new Date()).format('MMM DD YYYY'),
                etime: moment(new Date()).add(1, 'minutes').format('HH:mm'),
                driver: '70200025',
                city: 'bangalore',
                country: 'india',
                orderId: 1450,
                description: 'description',
            },
            {
                name: 'Field_Work_Force_Name_2',
                countryCode: '91',
                phone: '9493781078',
                email: 'email@gmail.com',
                FlatNo: '#44, 2nd floor, 1st cross, 2nd Main Rd',
                Area: 'Prasanth Layout',
                address: 'Prasanth Extension, Whitefield, Bengaluru, Karnataka 560066',
                latitude: '',
                longitude: '',
                sdate: moment(new Date()).format('MMM DD YYYY'),
                stime: moment(new Date()).format('HH:mm'),
                edate: moment(new Date()).format('MMM DD YYYY'),
                etime: moment(new Date()).add(1, 'minutes').format('HH:mm'),
                driver: '',
                city: 'bangalore',
                country: 'india',
                orderId: 1451,
                description: 'description',
            },
            {
                name: 'Field_Work_Force_Name_3',
                countryCode: '91',
                phone: '7586354334',
                email: 'email@gmail.com',
                FlatNo: '#44, 2nd floor, 1st cross, 2nd Main Rd',
                Area: 'Prasanth Layout',
                address: 'Prasanth Extension, Whitefield, Bengaluru, Karnataka 560066',
                latitude: '',
                longitude: '',
                sdate: moment(new Date()).format('MMM DD YYYY'),
                stime: moment(new Date()).format('HH:mm'),
                edate: moment(new Date()).format('MMM DD YYYY'),
                etime: moment(new Date()).add(1, 'minutes').format('HH:mm'),
                driver: '',
                city: 'bangalore',
                country: 'india',
                orderId: 1451,
                description: 'description',
            }
        ];
        this.xquara_pick_delivery = [
            {
                name: 'Pickup_Name',
                countryCode: '965',
                phone: '87654432',
                email: 'email@gmail.com',
                FlatNo: '#44, 2nd floor',
                address: 'Street 6, Salwa, Kuwait',
                latitude: '29.3018786',
                longitude: '48.07849059999999',
                date: moment(new Date()).format('MMM DD YYYY'),
                time: moment(new Date()).format('HH:mm'),
                driver: '70200025',
                city: 'Salwa',
                country: 'Kuwait',
                orderId: 54322,
                description: 'description',
                isPickup: 2,
                merchantId: "98844466",
                DeliveryName: 'Delivery_Name',
                DeliveryCountry_code: '965',
                DeliveryPhone: '87654432',
                DeliveryEmail: 'email@gmail.com',
                DeliveryFlatNo: '#44, 2nd floor',
                DeliveryAddress: 'Street 6, Salwa, Kuwait',
                DeliveryLatitude: '29.3018786',
                DeliveryLongitude: '48.07849059999999',
                DeliveryDate: moment(new Date()).format('MMM DD YYYY'),
                DeliveryTime: moment(new Date()).add(1, 'hours').format('HH:mm'),
                DeliveryCity: 'Salwa',
                DeliveryCountry: 'Kuwait',
                DeliveryOrder_id: '645343',
                DeliveryDescription: 'description'
            },
            {
                name: 'Pickup_Name',
                countryCode: '965',
                phone: '87654432',
                email: 'email@gmail.com',
                FlatNo: '#44, 2nd floor',
                address: 'Street 6, Salwa, Kuwait',
                latitude: '29.3018786',
                longitude: '48.07849059999999',
                date: moment(new Date()).format('MMM DD YYYY'),
                time: moment(new Date()).format('HH:mm'),
                driver: '70200025',
                city: 'Salwa',
                country: 'Kuwait',
                orderId: 1450,
                description: 'description',
                isPickup: 1,
                merchantId: "98844466",
                DeliveryName: '',
                DeliveryCountry_code: '',
                DeliveryPhone: '',
                DeliveryEmail: '',
                DeliveryAddress: '',
                DeliveryLatitude: '',
                DeliveryLongitude: '',
                DeliveryDate: '',
                DeliveryTime: '',
                DeliveryCity: '',
                DeliveryCountry: '',
                DeliveryOrder_id: '',
                DeliveryDescription: ''
            },
            {
                name: 'Delivery_Name',
                countryCode: '965',
                phone: '87654432',
                email: 'email@gmail.com',
                FlatNo: '#44, 2nd floor',
                address: 'Street 6, Salwa, Kuwait',
                latitude: '29.3018786',
                longitude: '48.07849059999999',
                date: moment(new Date()).format('MMM DD YYYY'),
                time: moment(new Date()).format('HH:mm'),
                driver: '70200025',
                city: 'Salwa',
                country: 'Kuwait',
                orderId: 1451,
                description: 'description',
                isPickup: 0,
                merchantId: "98844466",
                DeliveryName: '',
                DeliveryCountry_code: '',
                DeliveryPhone: '',
                DeliveryEmail: '',
                DeliveryAddress: '',
                DeliveryLatitude: '',
                DeliveryLongitude: '',
                DeliveryDate: '',
                DeliveryTime: '',
                DeliveryCity: '',
                DeliveryCountry: '',
                DeliveryOrder_id: '',
                DeliveryDescription: ''
            }
        ];
        this.xquara_appointment = [
            {
                name: 'Appointment_Name_1',
                countryCode: '965',
                phone: '87654432',
                email: 'email@gmail.com',
                FlatNo: '#44, 2nd floor',
                address: 'Street 6, Salwa, Kuwait',
                latitude: '29.3018786',
                longitude: '48.07849059999999',
                sdate: moment(new Date()).format('MMM DD YYYY'),
                stime: moment(new Date()).format('HH:mm'),
                edate: moment(new Date()).format('MMM DD YYYY'),
                etime: moment(new Date()).add(1, 'minutes').format('HH:mm'),
                driver: '70200025',
                city: 'Salwa',
                country: 'Kuwait',
                orderId: 1450,
                description: 'description',
                merchantId: "98844466",
            },
            {
                name: 'Appointment_Name_2',
                countryCode: '965',
                phone: '87654432',
                email: 'email@gmail.com',
                FlatNo: '#44, 2nd floor',
                address: 'Street 6, Salwa, Kuwait',
                latitude: '',
                longitude: '',
                sdate: moment(new Date()).format('MMM DD YYYY'),
                stime: moment(new Date()).format('HH:mm'),
                edate: moment(new Date()).format('MMM DD YYYY'),
                etime: moment(new Date()).add(1, 'minutes').format('HH:mm'),
                driver: '',
                city: 'Salwa',
                country: 'Kuwait',
                orderId: 1451,
                description: 'description',
                merchantId: "98844466"
            },
            {
                name: 'Appointment_Name_3',
                countryCode: '965',
                phone: '87654432',
                email: 'email@gmail.com',
                FlatNo: '#44, 2nd floor',
                address: 'Street 6, Salwa, Kuwait',
                latitude: '',
                longitude: '',
                sdate: moment(new Date()).format('MMM DD YYYY'),
                stime: moment(new Date()).format('HH:mm'),
                edate: moment(new Date()).format('MMM DD YYYY'),
                etime: moment(new Date()).add(1, 'minutes').format('HH:mm'),
                driver: '',
                city: 'Salwa',
                country: 'Kuwait',
                orderId: 1451,
                description: 'description',
                merchantId: "98844466"
            }
        ];
        this.xquara_workForce = [
            {
                name: 'Field_Work_Force_Name_1',
                countryCode: '965',
                phone: '87654432',
                email: 'email@gmail.com',
                FlatNo: '#44, 2nd floor',
                address: 'Street 6, Salwa, Kuwait',
                latitude: '12.427680',
                longitude: '76.451653',
                sdate: moment(new Date()).format('MMM DD YYYY'),
                stime: moment(new Date()).format('HH:mm'),
                edate: moment(new Date()).format('MMM DD YYYY'),
                etime: moment(new Date()).add(1, 'minutes').format('HH:mm'),
                driver: '70200025',
                city: 'Salwa',
                country: 'Kuwait',
                orderId: 1450,
                description: 'description',
                merchantId: "98844466",
            },
            {
                name: 'Field_Work_Force_Name_2',
                countryCode: '965',
                phone: '87654432',
                email: 'email@gmail.com',
                FlatNo: '#44, 2nd floor',
                address: 'Street 6, Salwa, Kuwait',
                latitude: '',
                longitude: '',
                sdate: moment(new Date()).format('MMM DD YYYY'),
                stime: moment(new Date()).format('HH:mm'),
                edate: moment(new Date()).format('MMM DD YYYY'),
                etime: moment(new Date()).add(1, 'minutes').format('HH:mm'),
                driver: '',
                city: 'Salwa',
                country: 'Salwa',
                orderId: 1451,
                description: 'description',
                merchantId: "98844466",
            },
            {
                name: 'Field_Work_Force_Name_3',
                countryCode: '965',
                phone: '87654432',
                email: 'email@gmail.com',
                FlatNo: '#44, 2nd floor',
                address: 'Street 6, Salwa, Kuwait',
                latitude: '',
                longitude: '',
                sdate: moment(new Date()).format('MMM DD YYYY'),
                stime: moment(new Date()).format('HH:mm'),
                edate: moment(new Date()).format('MMM DD YYYY'),
                etime: moment(new Date()).add(1, 'minutes').format('HH:mm'),
                driver: '',
                city: 'Salwa',
                country: 'Salwa',
                orderId: 1451,
                description: 'description',
                merchantId: "98844466",
            }
        ];
    }
    TaskSampleCSV.prototype.getValues = function (taskPincodeValue, category, taskImportUpdate, isMerchantEnable) {
        this.taskPincode = taskPincodeValue;
        this.category = category;
        this.taskImportUpdate = taskImportUpdate;
        this.isMerchantEnable = isMerchantEnable;
    };
    TaskSampleCSV.prototype.getHeaderOptions = function (data) {
        var taskOptions = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalseparator: '.',
            showLabels: true,
            showTitle: false,
            headers: getHeaders(data, this.category, this.taskPincode, this.categoryConst, this.taskImportUpdate, this.isMerchantEnable)
        };
        return taskOptions;
    };
    TaskSampleCSV.prototype.getDataOption = function (domain) {
        if (domain === 'app.xquara.co') {
            var xquaraTaskData = (this.category === this.categoryConst.PICKUP) ? this.xquara_pick_delivery : (this.category === this.categoryConst.APPOINTMENT) ? this.xquara_appointment : this.xquara_workForce;
            /*if (this.category === this.categoryConst.APPOINTMENT || this.category === this.categoryConst.FIELD) {
              Object.assign(taskData[0], {'edate': moment(new Date()).format('MMM DD YYYY'), 'etime': moment(new Date()).add(1, 'minutes').format('HH:mm')});
              Object.assign(taskData[1], {'edate': moment(new Date()).format('MMM DD YYYY'), 'etime': moment(new Date()).add(1, 'minutes').format('HH:mm')});
            }*/
            if (this.taskPincode) {
                Object.assign(xquaraTaskData[0], { 'pincode': 560097 });
                Object.assign(xquaraTaskData[1], { 'pincode': 560097 });
                Object.assign(xquaraTaskData[2], { 'pincode': 560097 });
            }
            else {
                delete xquaraTaskData[0]['pincode'];
                delete xquaraTaskData[1]['pincode'];
                delete xquaraTaskData[2]['pincode'];
            }
            if (this.taskImportUpdate) {
                Object.assign(xquaraTaskData[0], { 'Updation': '1' });
                Object.assign(xquaraTaskData[1], { 'Updation': '0' });
                Object.assign(xquaraTaskData[2], { 'Updation': '0' });
                Object.assign(xquaraTaskData[0], { 'taskId': '556443369' });
                Object.assign(xquaraTaskData[1], { 'taskId': '' });
                Object.assign(xquaraTaskData[2], { 'taskId': '' });
            }
            else {
                delete xquaraTaskData[0]['Updation'];
                delete xquaraTaskData[1]['Updation'];
                delete xquaraTaskData[2]['Updation'];
                delete xquaraTaskData[0]['taskId'];
                delete xquaraTaskData[1]['taskId'];
                delete xquaraTaskData[2]['taskId'];
            }
            return xquaraTaskData;
        }
        else {
            var taskData = (this.category === this.categoryConst.PICKUP) ? this.pick_delivery : (this.category === this.categoryConst.APPOINTMENT) ? this.appointment : this.workForce;
            /*if (this.category === this.categoryConst.APPOINTMENT || this.category === this.categoryConst.FIELD) {
              Object.assign(taskData[0], {'edate': moment(new Date()).format('MMM DD YYYY'), 'etime': moment(new Date()).add(1, 'minutes').format('HH:mm')});
              Object.assign(taskData[1], {'edate': moment(new Date()).format('MMM DD YYYY'), 'etime': moment(new Date()).add(1, 'minutes').format('HH:mm')});
            }*/
            if (this.taskPincode) {
                Object.assign(taskData[0], { 'pincode': 560097 });
                Object.assign(taskData[1], { 'pincode': 560097 });
                Object.assign(taskData[2], { 'pincode': 560097 });
            }
            else {
                delete taskData[0]['pincode'];
                delete taskData[1]['pincode'];
                delete taskData[2]['pincode'];
            }
            if (this.isMerchantEnable) {
                Object.assign(taskData[0], { 'MerchantId': '98766554' });
                Object.assign(taskData[1], { 'MerchantId': '' });
                Object.assign(taskData[2], { 'MerchantId': '' });
            }
            else {
                delete taskData[0]['MerchantId'];
                delete taskData[1]['MerchantId'];
                delete taskData[1]['MerchantId'];
            }
            if (this.taskImportUpdate) {
                Object.assign(taskData[0], { 'Updation': '1' });
                Object.assign(taskData[1], { 'Updation': '0' });
                Object.assign(taskData[2], { 'Updation': '0' });
                Object.assign(taskData[0], { 'taskId': '556443369' });
                Object.assign(taskData[1], { 'taskId': '' });
                Object.assign(taskData[2], { 'taskId': '' });
            }
            else {
                delete taskData[0]['Updation'];
                delete taskData[1]['Updation'];
                delete taskData[2]['Updation'];
                delete taskData[0]['taskId'];
                delete taskData[1]['taskId'];
                delete taskData[2]['taskId'];
            }
            return taskData;
        }
    };
    TaskSampleCSV = __decorate([
        Injectable()
    ], TaskSampleCSV);
    return TaskSampleCSV;
}());
export { TaskSampleCSV };
function getHeaders(title, category, taskPinCode, categoryConst, taskImportUpdate, isMerchantEnable) {
    var defaultHeaderArr;
    if (title === 'importOption') {
        defaultHeaderArr = ['Name', 'Country_code*', 'Phone*', 'Email', 'FlatNo', 'Area', 'Address*', 'Latitude', 'Longitude', 'Date*', 'Time*', 'DriverId', 'City', 'Country', 'OrderId', 'Description'];
        if (category === categoryConst.APPOINTMENT || category === categoryConst.FIELD) {
            defaultHeaderArr[9] = 'Start_Date*';
            defaultHeaderArr[10] = 'Start_Time*';
            defaultHeaderArr.splice(11, 0, 'End_Date*');
            defaultHeaderArr.splice(12, 0, 'End_Time*');
        }
        else {
            defaultHeaderArr.push('isPickup*');
            defaultHeaderArr.push('DeliveryName');
            defaultHeaderArr.push('DeliveryCountry_code*');
            defaultHeaderArr.push('DeliveryPhone*');
            defaultHeaderArr.push('DeliveryEmail');
            defaultHeaderArr.push('DeliveryFlatNo');
            defaultHeaderArr.push('DeliveryArea');
            defaultHeaderArr.push('DeliveryAddress*');
            defaultHeaderArr.push('DeliveryLatitude');
            defaultHeaderArr.push('DeliveryLongitude');
            defaultHeaderArr.push('DeliveryDate*');
            defaultHeaderArr.push('DeliveryTime*');
            defaultHeaderArr.push('DeliveryCity');
            defaultHeaderArr.push('DeliveryCountry');
            defaultHeaderArr.push('DeliveryOrder_id');
            defaultHeaderArr.push('DeliveryDescription');
        }
        if (taskPinCode) {
            defaultHeaderArr.push('Pincode');
        }
        if (isMerchantEnable) {
            defaultHeaderArr.push('MerchantId');
        }
        if (taskImportUpdate) {
            defaultHeaderArr.push('Updation');
            defaultHeaderArr.push('taskId');
        }
    }
    else {
        defaultHeaderArr = ['Task_id', 'Name', 'Phone_number', 'Email_id', 'Flat_No', 'Area', 'Address', 'Description', 'Agent', 'Team', 'Order_id', 'Task_Type', 'Distance', 'Task_status', 'Latitude', 'Longitude', 'Rating', 'Comment', 'notes', 'barcode', 'Signature', 'Images', 'Ref_Image', 'Delay', 'Start_Before', 'Complete_Before', 'Started_Time', 'Completion_Time', 'Total_Time_Taken', 'Template_Id', 'Template_Name'];
        if (taskPinCode) {
            defaultHeaderArr.push('Pincode');
        }
    }
    return defaultHeaderArr;
}



//////////////////
// WEBPACK FOOTER
// ./src/app/tasks/taskSampleCSV.ts
// module id = ./src/app/tasks/taskSampleCSV.ts
// module chunks = main